<template>
  <div class="screen" :class="seasonClass">
    <div class="page" :class="group === 1 ? 'page2' : ''">
      <div class="userinfo" v-if="userInfo"><span class="mr-20">姓名：{{ userInfo.userName }}</span><span>比赛号码：{{ addZero(userInfo.matchNum) }}</span></div>
      <img class="home-light" @click="backToHome" src="https://cdn.spbcn.org/chineseWord/applets/images/home_light.png" alt="">
      <div class="header" v-if="seasonClass === 'season1'">
        <img class="logo" src="https://cdn.spbcn.org/chineseWord/applets/images/final_center.png">
      </div>
      <div class="season2-logo" v-if="seasonClass === 'season2'">
        <img class="img" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/logo.png" alt="">
        <img class="img" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season3/season3.png" alt="">
      </div>
      <div class="page-box">
        <div class="season2-title season2-title1" v-if="group === 1 && seasonClass === 'season2'">
          <div class="cn">小组赛A轮</div>
          <div class="en">Group Competition Round A</div>
        </div>
        <div class="season2-title season2-title2" v-if="group === 2 && seasonClass === 'season2'">
          <div class="cn">无组别挑战赛A轮</div>
          <div class="en">Mixed Group Competition Round A</div>
        </div>
        <div class="content">
          <img :src=" seasonClass === 'season1' ? 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_over_icon.png' : 'https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png'" alt="">
          <div>本轮比赛已结束</div>
          <div>Round A Completed</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      seasonClass: '',
      season: '',
      group: '',
      userInfo: {} // 登录用户个人信息
    }
  },
  created () {
    document.title = '汉英双拼大会'
    this.group = Number(this.$route.query.g)
    this.userInfo = JSON.parse(localStorage.getItem('PAD_USER_INFO'))
    console.log(this.userInfo)
    const season = this.$route.query.season
    this.season = season
    this.seasonClass = season === '2022~2023' ? 'season1' : season === '2023~2024' ? 'season2' : ''
  },
  methods: {
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    backToHome () {
      localStorage.clear()
      this.$router.push(`/pad/pw?season=${this.season}&enter=1`)
    }
  }
}
</script>
<style scoped lang="less">
.screen{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  font-family: 'regular';
}
.page{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg2.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
}
.page2{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg1.png);
}
.header{
  margin-top: 32px;
  height: 84px;
  display: flex;
  justify-content: center;
  position: relative;
  .logo{
    width: 220px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
}
.content{
  text-align: center;
  font-size: 32px;
  img{
    width: 180px;
    margin-bottom: 24px;
  }
}
.userinfo{
  position: absolute;
  right: 24px;
  top: 14px;
  color: #000;
  font-size: 16px;
  font-family: fzcsk;
  .mr-20{
    margin-right: 10px;
  }
}
.home-light{
  width: 30px;
  position: fixed;
  bottom: 14px;
  right: 14px;
}
.season1{
  .page{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg2.png);
  }
}
.season1 .page2{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg1.png);
}
.season2{
  .page{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .season2-logo{
    position: absolute;
    left: 40px;
    right: 40px;
    top: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img{
      height: 40px;
      width: auto;
    }
  }
  .page-box{
    width: 94%;
    min-height: 70vh;
    background: rgba(255, 248, 225, .7);
    border-radius: 20px;
    padding: 60px;
    box-sizing: border-box;
    margin-top: 60px;
  }
  .userinfo{
    // top: 124px;
    // right: 58px;
    top: 88px;
    right: 40px;
  }
  .season2-title{
    height: 64px;
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    font-family: regular;
    text-align: center;
    padding-top: 12px;
    box-sizing: border-box;
    margin-bottom: 40px;
    .cn{
      font-size: 20px;
    }
    .en{
      font-size: 12px;
    }
  }
  .season2-title1{
    color: #000;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg2.png);
  }
  .season2-title2{
    color: #fff;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
  }
  .content img{
    width: 140px;
    margin-top: 20px;
    margin-bottom: 40px;
  }
}

</style>
